import { isDesktop } from 'react-device-detect';
import './Intro.scss';
import { Button, Theme } from '../components/button/Button';

export function Intro() {
  return (
    <>
      <section id="intro" className="intro">
        {isDesktop && (
          <a href="#prestations">
            <Button
              label="Découvrir les prestations"
              theme={Theme.DARK}
              enableHover
            />
          </a>
        )}
        <div className="japanese-massage">
          <h1 className="intro-text lato-thin m-0">
            MASSAGES
            <br />
            ANTI-ÂGE NATURELS
            <br />
            PARIS
          </h1>
        </div>
      </section>
    </>
  );
}
